import React from 'react';
import PropTypes from 'prop-types';
import { Accordion as AccordionBootstrap, Card, Button as ButtonBoostrap } from 'react-bootstrap';
import HelpButton from '../../atoms/helpButton/helpButton';
import Button, { ButtonSize, ButtonTheme, ButtonType } from '../../atoms/button/button';
import './accordion.scss';
/**
 * Accordion is used to group of HTML or component elements. It has a header Button, HelpButton, Catalog button and an area to group HTML or component elements. If the user clicks on the header button, the content is hidden or showed.
 */
const Accordion = (props) => {
  const {
    id, title, children, helpText, onClickLoadFromCatalog, canDuplicate, onClickRemove,rightBlockElement,className,
  } = props;

  return (
    <AccordionBootstrap id={id} defaultActiveKey="0" className={className}>
      <Card>
        <Card.Header className="accordion__header">
          <AccordionBootstrap.Toggle as={ButtonBoostrap} variant="link" eventKey="0">
            {title}
          </AccordionBootstrap.Toggle>
          { helpText !== ''
            && (
              <HelpButton>{helpText}</HelpButton>
            )}
          { onClickLoadFromCatalog !== null
            && (
              <Button type={ButtonType.BUTTON} className="float-right text-info" onClick={onClickLoadFromCatalog} theme={ButtonTheme.LINK} size={ButtonSize.LARGE}>
                Load From Catalog
              </Button>
            )}
          { canDuplicate === true
          && (
            <div  className="float-right accordion__duplicate"> 

              <Button id={id+'-remove'} type={ButtonType.BUTTON} onClick={onClickRemove} theme={ButtonTheme.ERROR_OUTLINE} size={ButtonSize.MEDIUM}>
                -
              </Button>
            </div>
          )}
          {rightBlockElement !==null 
          && (
            <div className={"float-right"}>
              {rightBlockElement}
            </div>
          )}
        </Card.Header>
        <AccordionBootstrap.Collapse eventKey="0">
          <Card.Body>
            {children}
          </Card.Body>
        </AccordionBootstrap.Collapse>
      </Card>
    </AccordionBootstrap>
  );
};

Accordion.propTypes = {
  /**
   * component id
   */
  id: PropTypes.string,
  /**
   * Accordion title
   */
  title: PropTypes.string,
  /**
   * JSX content to display inside the accordion
   */
  children: PropTypes.node,
  /**
   * Text to add inside the header help button
   */
  helpText: PropTypes.string,
  /**
   * Function to bind Catalog link onClick
   */
  onClickLoadFromCatalog: PropTypes.func,

    /**
   * Function to bind Catalog link onClick
   */
  onClickRemove: PropTypes.func,
    /**
   * Accordion duplication
   */
  canDuplicate: PropTypes.bool,
};

Accordion.defaultProps = {
  id: '',
  title: '',
  children: '',
  helpText: '',
  onClickLoadFromCatalog: null,
  onClickRemove: null,
  onClickDuplicate: null,
};


export default Accordion;
